import Vue from "vue";
import VueI18n from "vue-i18n";

import defaultLocaleFile from "./lang/en";
import Trimaster from "./plugins/servers/trimaster.js";

// import enLocale from "moment/locale/en";
import moment from "moment";
import esLocale from "moment/locale/es";

Vue.use(VueI18n);

const defaultLocale = "en";

export const i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: defaultLocale,
  messages: { [defaultLocale]: defaultLocaleFile }
});

const setI18nLanguage = lang => {
  i18n.locale = lang;
  document.querySelector("html").setAttribute("lang", lang);
  localStorage.setItem("currentLocale", lang);
  moment.locale(lang, [esLocale]);
  return lang;
};

const loadedLanguages = ["en"];

export async function loadLanguageAsync(lang) {
  return import(`./lang/${lang}.js`).then(messages => {
    i18n.setLocaleMessage(lang, messages.default);
    loadedLanguages.push(lang);
    return setI18nLanguage(lang);
  });
}

export async function initI18n() {
  const userJson = localStorage.getItem("user") || null;
  const user = userJson ? JSON.parse(userJson) : null;
  let currentLocale = localStorage.getItem("currentLocale") || defaultLocale;

  if (user && user.id && user.apitoken) {
    const res = await Trimaster.get(`users/${user.id}`, user.apitoken, {
      filter: {
        include: ["roles"]
      }
    });

    if (res && res.length) {
      const data = res[0];
      currentLocale = data.lang;
    }
  }

  return loadLanguageAsync(currentLocale).then(() => i18n);
}
